import classNames from 'classnames';
import styles from './snake-pager.module.scss';

type SnakePagerProps = {
    className?: string;
    page: number;
    pages: number;
    timer: number;
};

const SnakePager = ({ className, page, pages, timer }: SnakePagerProps) => {
    return (
        <div className={classNames(styles['snake-pager'], className)}>
            {Array.from({ length: pages }).map((_, index) => (
                <span
                    key={index}
                    className={classNames(styles['snake-pager__item'], {
                        [styles['active']]: index === page,
                    })}
                    style={{
                        transitionDuration: `${timer}ms`,
                    }}
                />
            ))}
        </div>
    );
};

export default SnakePager;
